<span *ngIf="pipe === type.ACTIVE">
  {{value | active }}
</span>
<span *ngIf="pipe === type.BIOEXAMS_STATUS">
  {{value | bioexamsStatusPipe }}
</span>
<span *ngIf="pipe === type.CNPJ">
  {{value | cnpjPipe }}
</span>
<span *ngIf="pipe === type.CPF">
  {{value | cpfPipe }}
</span>
<span *ngIf="pipe === type.CURRENCY">
  {{value | currency:'BRL':'symbol':'1.2-2'}}
</span>
<span *ngIf="pipe === type.DATABASE_OPTIONS">
  {{value | databaseOptions}}
</span>
<span *ngIf="pipe === type.DATE">
  {{value | date:'dd/MM/yyyy'}}
</span>
<span *ngIf="pipe === type.DATE_AND_TIME">
  {{value | dateAndTimePipe}}
</span>
<span *ngIf="pipe === type.DATE_TO_FRONT">
  {{value | dateToFront}}
</span>
<span *ngIf="pipe === type.FINANCIAL_OCCURRENCE_TYPE">
  {{value | financialOccurrenceTypePipe }}
</span>
<span *ngIf="pipe === type.FINANCIAL_PEOPLE_SITUATION_PIPE">
  {{value | financialPeopleSituationPipe }}
</span>
<span *ngIf="pipe === type.FINANCIAL_PEOPLE_ADDRESS">
  {{value | financialPeopleAddressPipe }}
</span>
<span *ngIf="pipe === type.FINANCIAL_RELEASE_GROUPE_TYPE_PIPE">
  {{value | financialReleaseGroupTypePipe }}
</span>
<span *ngIf="pipe === type.FORMAT_NAME">
  {{value | formatName }}
</span>
<span *ngIf="pipe === type.PHONE">
  {{value | phone }}
</span>
<span *ngIf="pipe === type.REMOVE_UNDERSCORE">
  {{value | removeUnderscore }}
</span>
<span *ngIf="pipe === type.SITUATION_REGISTRATION">
  {{value | situationRegistration }}
</span>
<span *ngIf="pipe === type.SITUATION">
  {{value | situationPipe }}
</span>
<span *ngIf="pipe === type.TIME_TO_FRONT">
  {{value | timeToFront }}
</span>
<span *ngIf="pipe === type.TRUE_FALSE">
  {{value | truefalse }}
</span>
<span *ngIf="pipe === type.TYPE_PEOPLE">
  {{value | typePeoplePipe }}
</span>
<span *ngIf="pipe === type.TYPE_DOCUMENT">
  {{value | typedocument }}
</span>
<span *ngIf="pipe === type.TYPE_GROUP">
  {{value | typeGroup }}
</span>
<span *ngIf="pipe === type.TYPE_RELEASE">
  {{value | typeReleasePipe }}
</span>
<span *ngIf="pipe === type.TYPE_OF_PRACTICAL_SCHEDULING_PIPES">
  {{value | typeOfPracticalSchedulingPipe }}
</span>
<span *ngIf="pipe === type.TYPE_PRODUCT">
  {{value | typeProduct }}
</span>

